import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { RegistrationComponent } from "./registration/registration.component";
import { ContractComponent } from "./contract/contract.component";
import { AuthGuardService } from "./guards/auth-guard.service";
import { AuthGuard2Service } from "./guards/auth-guard2.service";
import { Registration1Component } from "./registration1/registration1.component";
import { HomePageComponent } from "./home-page/home-page.component";
import { WelcomeComponent } from "./welcome/welcome.component";
import { ErrorComponent } from "./error/error.component";
import { SessionTimeOutComponent } from "./session-time-out/session-time-out.component";
import { AppfolioRegistrationComponent } from "./appfolio/registration/appfolio-registration.component";
import { AppFolioWelcomeComponent } from "./appfolio/welcome/appfolio-welcome.component";
import { AppfolioContractComponent } from "./appfolio/contract/appfolio-contract.component";
import { AuthGuard3Service } from "./guards/appfolio-auth-guard.service";
import { AppFolioHomePage } from "./appfolio/home-page/appfolio-home-page.component";

const routes: Routes = [
  { path: "", component: HomePageComponent },
  { path: "registration", component: RegistrationComponent },
  {
    path: "registration1",
    canActivate: [AuthGuard2Service],
    component: Registration1Component,
  },
  {
    path: "contract",
    canActivate: [AuthGuardService],
    component: ContractComponent,
  },
  {
    path: "welcome",
    canActivate: [AuthGuardService],
    component: WelcomeComponent,
  },
  { path: "timeout", component: SessionTimeOutComponent },
  { path: "error", component: ErrorComponent },
  { path: "appfolio", component: AppFolioHomePage },
  { path: "appfolio/registration", component: AppfolioRegistrationComponent },
  {
    path: "appfolio/welcome",
    canActivate: [AuthGuard3Service],
    component: AppFolioWelcomeComponent,
  },
  {
    path: "appfolio/contract",
    canActivate: [AuthGuard3Service],
    component: AppfolioContractComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
